<template>
  <div class="menu-item">
    <div class="menu-content pb-2">
      <span class="menu-section text-muted text-uppercase fs-8 ls-1">{{content.title}}</span>
    </div>
  </div>
  <div class="menu-item"
       :class="{
          'menu-accordion': !!menu.menus,
          'hover show': !!menu.menus && menu.component.includes(pageComponent),
          'd-none': !!menu.can ? !can(menu.can) : false
        }"
       :data-kt-menu-trigger="menu.menus ? 'click' : null" v-for="menu in content.menus">
    <span class="menu-link" v-if="menu.menus" :class="{ 'active': activeComponent(menu.component)}">
      <span class="menu-icon">
            <i class="bi fs-3" :class="menu.icon"></i>
      </span>
      <span class="menu-title">{{menu.name}}</span>
      <span class="menu-arrow"></span>
    </span>

    <div class="menu-sub menu-sub-accordion" :class="{'show': $page.component.includes(menu.component)}" v-if="menu.menus">
      <div class="menu-item" v-for="submenu in menu.menus">
        <Link class="menu-link" :class="{ 'active': activeComponent(submenu.component)}" :href="submenu.link" :target="submenu.target">
            <span class="menu-bullet">
              <span class="bullet bullet-dot"></span>
            </span>
          <span class="menu-title">{{submenu.name}}</span>
        </Link>
      </div>
    </div>

    <Link v-else class="menu-link" :class="{ 'active': activeComponent(menu.component)}" :href="menu.link" :target="menu.target">
      <span class="menu-icon">
            <i class="bi fs-3" :class="menu.icon"></i>
      </span>
      <span class="menu-title">{{menu.name}}</span>
    </Link>
  </div>
</template>

<script>

import { Link } from "@inertiajs/inertia-vue3";

export default {
  components: {
    Link,
  },
  props: {
    content: {
      required: true
    }
  },
  computed: {
    pageComponent() {
      let array = this.$page.component.split('/')
      return array[array.length-1]
    },
    pageCompoenentSlash() {

    }
  },
  methods: {
    activeComponent(menuComponent) {
      //Verifica se o componente do menu é um submenu tipo Usuarios/Edit
      if (Array.isArray(menuComponent)) {
        return !!menuComponent.find(menu => this.$page.component.split('/').find(comp => comp === menu));
      }

      return this.pageComponent === menuComponent
    }
  }
}
</script>
